import pageSidebar from "./directive";
import pageSidebarMobile from "./mobile-page-sidebar";

const modul = angular
    .module("pageSidebarModule", [])

    .directive("pageSidebar", pageSidebar)
    .directive("pageSidebarMobile", pageSidebarMobile);

export default modul.name;
